import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  FormHelperText,
  Typography,
} from '@mui/material'
import theme from 'lib/theme'
import { useTranslation } from 'react-i18next'

interface SelectDropdownProps {
  marginBottom?: string
  errorMessage?: string
  disabled?: boolean
  label: string
  selectedValue: string
  selectOptions: { label: string; value: string }[]
  handleChange: (value: string) => void
  customMessage?: string
  customPlaceholderMessage?: string
  handleBlur?: () => void
}

export const SelectDropdown = ({
  errorMessage,
  selectedValue,
  handleChange,
  selectOptions,
  label,
  customMessage = '',
  marginBottom,
  disabled,
  customPlaceholderMessage,
  handleBlur,
}: SelectDropdownProps) => {
  const { t } = useTranslation()
  return (
    <FormControl
      disabled={disabled}
      size='small'
      sx={{
        width: '100%',
        marginBottom: marginBottom || theme.spacing(4),
      }}>
      <InputLabel
        sx={{
          fontWeight: 'bold',
          top: '-6px',
          left: '-8px',
          '&.Mui-disabled': {
            color: theme.palette.text.secondary,
          },
        }}
        shrink>
        {label}
      </InputLabel>
      <Select
        onBlur={handleBlur}
        variant='filled'
        sx={{
          '& .MuiSelect-select': { padding: theme.spacing(1) },
          '& .Mui-disabled': {
            WebkitTextFillColor: theme.palette.text.disabled,
          },
        }}
        displayEmpty
        renderValue={() => {
          return !selectedValue || selectedValue.length === 0 ? (
            <Typography
              sx={{
                color: theme.palette.text.secondary,
                fontSize: '12px',
                fontWeight: 'bold',
                lineHeight: 2,
                ...(customPlaceholderMessage && {
                  fontSize: '18px',
                  fontWeight: 'normal',
                  lineHeight: 1.5,
                }),
              }}>
              {customPlaceholderMessage || t('select')}
            </Typography>
          ) : (
            selectOptions.filter((option) => option.value === selectedValue)[0]
              ?.label || customMessage
          )
        }}
        value={selectedValue}
        onChange={(e) => handleChange(e.target.value)}>
        {selectOptions.map(({ label, value }) => (
          <MenuItem
            key={value + label}
            value={value}
            sx={{ whiteSpace: 'normal' }}>
            {label}
          </MenuItem>
        ))}
      </Select>
      <FormHelperText>{errorMessage}</FormHelperText>
    </FormControl>
  )
}
